import { ticketCategories, type TicketCategory } from "@megaron/support-contracts";

export const supportTicketCategoryLabels: Record<TicketCategory, string> = {
  complaint: "Reklamacja",
  question: "Sygnał reklamacyjny",
  opinion: "Opinie",
};

export const supportTicketCategoryCreateOptions: { label: string; value: TicketCategory }[] = [
  { label: supportTicketCategoryLabels.complaint, value: "complaint" },
  { label: supportTicketCategoryLabels.question, value: "question" },
  { label: supportTicketCategoryLabels.opinion, value: "opinion" },
];

export const isTicketCategory = (value: string): value is TicketCategory =>
  ticketCategories.some((category) => category === value);

export const getSupportTicketCategoryLabel = (category: TicketCategory | null | undefined): string | null => {
  if (!category) return null;
  return supportTicketCategoryLabels[category] ?? category;
};
